import { Typography } from "@mui/material";
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';
import InventoryListData from "../../components/Inventory/InventoryList";

const InventoryList =() => {
  return(
    <>
     {/* <Breadcrumb /> */}
         <InventoryListData/>
    </>
  );
};
export default InventoryList;